import { render, staticRenderFns } from "./TourMenu.vue?vue&type=template&id=6ac5b0bb&scoped=true&"
import script from "./TourMenu.vue?vue&type=script&lang=js&"
export * from "./TourMenu.vue?vue&type=script&lang=js&"
import style0 from "./TourMenu.vue?vue&type=style&index=0&id=6ac5b0bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac5b0bb",
  null
  
)

export default component.exports